export const initialReviews  = [
    {
      name: "Александр",
      date: "2024-06-25",
      review: "Отличный обменник, все прошло быстро и безопасно!",
    },
    {
      name: "Мария",
      date: "2024-06-23",
      review: "Очень довольна обменом, всё сделано качественно!",
    },
    {
      name: "Иван",
      date: "2024-06-27",
      review: "Хорошие условия для обмена, всё прошло без проблем.",
    },
    {
      name: "Ольга",
      date: "2024-06-22",
      review: "Быстрая и надежная сделка, буду пользоваться снова.",
    },
    {
      name: "Дмитрий",
      date: "2024-06-29",
      review: "Отличный обменник с хорошими курсами и сервисом.",
    },
    {
      name: "Елена",
      date: "2024-06-26",
      review: "Все очень понравилось, обмен прошел без задержек.",
    },
    {
      name: "Максим",
      date: "2024-06-24",
      review: "Сервис на высшем уровне, рекомендую всем!",
    },
    {
      name: "Анна",
      date: "2024-06-27",
      review: "Очень довольна, обмен прошел гладко и быстро.",
    },
    {
      name: "Владимир",
      date: "2024-06-21",
      review: "Хороший обменник, но курс мог бы быть чуть лучше.",
    },
    {
      name: "Ирина",
      date: "2024-06-28",
      review: "Всё прошло хорошо, обмен прошёл без проблем.",
    },
    {
      name: "Андрей",
      date: "2024-06-30",
      review: "Все очень понравилось, качественный обмен.",
    },
    {
      name: "Юлия",
      date: "2024-06-23",
      review: "Рекомендую этот обменник, отличное обслуживание!",
    },
    {
      name: "Сергей",
      date: "2024-06-25",
      review: "Всё прошло отлично, быстро и безопасно.",
    },
    {
      name: "Татьяна",
      date: "2024-06-26",
      review: "Приятно удивлена качеством обмена и оперативностью.",
    },
    {
      name: "Анатолий",
      date: "2024-06-24",
      review: "Отличный обменник с хорошими курсами, всем советую.",
    },
    {
      name: "Наталья",
      date: "2024-06-30",
      review: "Все отлично, обмен прошел быстро и легко.",
    },
    {
      name: "Валерий",
      date: "2024-06-20",
      review: "Хороший обменник, но немного завышенные комиссии.",
    },
    {
      name: "Екатерина",
      date: "2024-06-28",
      review: "Всё прошло замечательно, обменом довольна!",
    },
    {
      name: "Олег",
      date: "2024-06-27",
      review: "Обмен прошел без проблем, курс вполне нормальный.",
    },
    {
      name: "Надежда",
      date: "2024-06-22",
      review: "Очень хороший обменник, всё четко и быстро.",
    },
    {
      name: "Артем",
      date: "2024-06-25",
      review: "Отличный сервис, обмен прошел быстро и без проблем.",
    },
    {
      name: "Светлана",
      date: "2024-06-29",
      review: "Обмен прошел гладко, рекомендую этот сервис!",
    },
    {
      name: "Константин",
      date: "2024-06-24",
      review: "Хорошие условия для обмена, всё сделано быстро.",
    },
    {
      name: "Алина",
      date: "2024-06-26",
      review: "Очень довольна обменом, курс был отличным!",
    },
    {
      name: "Вячеслав",
      date: "2024-06-23",
      review: "Обмен прошел хорошо, но курс мог бы быть лучше.",
    },
    {
      name: "Галина",
      date: "2024-06-30",
      review: "Отличный обменник, все очень понравилось!",
    },
    {
      name: "Станислав",
      date: "2024-06-28",
      review: "Обмен прошел быстро, все было на высшем уровне.",
    },
    {
      name: "Вера",
      date: "2024-06-21",
      review: "Все отлично, обмен прошел быстро и безопасно.",
    },
    {
      name: "Виктор",
      date: "2024-06-24",
      review: "Хорошие условия для обмена, всё прошло отлично.",
    },
    {
      name: "Нина",
      date: "2024-06-27",
      review: "Обмен прошел без задержек, качественный сервис.",
    },
    {
      name: "Денис",
      date: "2024-06-25",
      review: "Очень доволен обменом, все сделано быстро и безопасно.",
    },
    {
      name: "Евгения",
      date: "2024-06-26",
      review: "Отличное обслуживание, курс мог бы быть лучше.",
    },
    {
      name: "Юрий",
      date: "2024-06-30",
      review: "Всё прошло хорошо, обмен прошел быстро и удобно.",
    },
    {
      name: "Людмила",
      date: "2024-06-20",
      review: "Отличный обменник, всё прошло отлично!",
    },
    {
      name: "Сергей",
      date: "2024-06-28",
      review: "Всё на высшем уровне, обмен прошел без проблем.",
    },
    {
      name: "Татьяна",
      date: "2024-06-22",
      review: "Хороший обменник, курс и условия отличные.",
    },
    {
      name: "Петр",
      date: "2024-06-27",
      review: "Обмен прошел отлично, все устроило!",
    },
    {
      name: "Елена",
      date: "2024-06-29",
      review: "Отличный обменник, все сделано быстро и качественно.",
    },
    {
      name: "Алексей",
      date: "2024-06-21",
      review: "Хороший обменник, все прошло без проблем.",
    },
    {
      name: "Ирина",
      date: "2024-06-26",
      review: "Очень довольна обменом, сервис отличный.",
    },
    {
      name: "Владимир",
      date: "2024-06-23",
      review: "Обмен прошел хорошо, рекомендую этот обменник.",
    },
    {
      name: "Ольга",
      date: "2024-06-25",
      review: "Курс отличный, обмен прошел быстро.",
    },
    {
      name: "Михаил",
      date: "2024-06-24",
      review: "Обмен прошел быстро и без проблем.",
    },
    {
      name: "Екатерина",
      date: "2024-06-27",
      review: "Очень хороший обменник, буду заказывать еще.",
    },
    {
      name: "Игорь",
      date: "2024-06-30",
      review: "Отличное качество, всё сделано быстро и безопасно.",
    },
    {
      name: "Анна",
      date: "2024-06-22",
      review: "Обмен прошел отлично, все быстро и удобно.",
    },
    {
      name: "Максим",
      date: "2024-06-26",
      review: "Курс отличный, обмен прошел без проблем.",
    },
    {
      name: "Марина",
      date: "2024-06-28",
      review: "Всё прошло хорошо, обменник гуд",
    },
  ];